import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Sort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { debounceTime, Subject, tap } from 'rxjs';
import {
  Facilitator,
} from 'src/app/interfaces/facilitator.interface';
import {
  GroupDetail,
} from 'src/app/interfaces/group.interface';
import { FacilitatorserviceService } from 'src/app/services/facilitatorservice.service';
import { GroupService } from 'src/app/services/groupservice.service';
import {
  CATEGORY_OPTIONS_ALLIED,
  FACILITATOR_COLOR_STATUS,
  LIST_FACILITATOR_COLUMN,
  ORDER_LIST_FACILITATOR,
} from 'src/app/shared/data/data';
import { RequestStatus, statusFacilitator } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-list-facilitator',
  templateUrl: './list-facilitator.component.html',
  styleUrls: ['./list-facilitator.component.scss'],
})
export class ListFacilitatorComponent implements OnInit, OnDestroy {
  @Output() noMatches = new EventEmitter<number>();
  @Input() public organizationIndex: string;
  @Input() valorFiltro: string;

  private subs = new SubSink();
  private readonly searchSubject = new Subject<string | undefined>();
  public listGroups: GroupDetail[] = [];
  public listGroupByFacilitator: GroupDetail[];
  public displayedColumns: string[] = LIST_FACILITATOR_COLUMN;
  public dataSource = new MatTableDataSource<Facilitator>([]);
  public dataSourceNew = new MatTableDataSource<Facilitator>([]);
  public dataCountry = CATEGORY_OPTIONS_ALLIED;
  public list: any[] = [];
  public listSort = ORDER_LIST_FACILITATOR;
  public validator: number;
  public statusDetail: RequestStatus = 'init';
  public isEmptySearch: boolean = false;
  public facilitatorStatus = FACILITATOR_COLOR_STATUS;
  public search: string = '';
  public noInitialData: boolean = false;
  //pagination
  public page = 1;
  public size = 10;
  public pageSize: number = 10;
  public totalItems = 0;
  public pageIndex: number = 0;
  public pageEvent: PageEvent;

  public length = 0;
  public sortField: string = 'names';
  public sortDirection: string = 'asc';
  public status: string = 'all';

  constructor(
    private router: Router,
    private facilitatorService: FacilitatorserviceService,
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.facilitatorService.filterByStatus$.subscribe((filter) => {
      // Handle the event data
      this.status = filter;
      this.loadData();
    });

    this.subs.sink = this.searchSubject
    .pipe(debounceTime(300))
    .subscribe((searchTerm: string | undefined) => {
      this.search = searchTerm || '';
      this.loadData();
    });

    this.loadData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public onSearchQueryInput(event: Event): void {
    const searchQuery = (event.target as HTMLInputElement).value;
    this.pageIndex = 0; // Reset to the first page on search
    this.searchSubject.next(searchQuery?.trim());
  }

  sortData(sort: Sort) {
    //this.statusDetail = 'loading';
    this.sortField = sort.active;
    this.sortDirection = sort.direction;
    this.loadData();
  }

  private loadData() {
    this.subs.sink = this.facilitatorService.facilitatorsList(this.status, this.organizationIndex, this.pageIndex, this.pageSize, this.sortField, this.sortDirection, this.search)
      .pipe(tap(() => (this.statusDetail = 'success')))
      .subscribe((rta: any) => {
        this.dataSource.data = rta.facilitators;

        this.length = rta.totalElements;
        this.isEmptySearch = this.dataSource.data.length === 0;
      });
  }


  public goToSpecificFacilitator(id: string): void {
    this.router.navigate([`pages/userdash/facilitator/${id}`]);
  }

  public handlePageEvent(ev: PageEvent): void {
    this.statusDetail = 'loading';
    this.pageIndex = ev.pageIndex + 1;
    this.pageSize = ev.pageSize;

    this.loadData();
    this.statusDetail = 'success';
  }

  public chooseColorAndText(status: statusFacilitator): any {
    return this.facilitatorStatus[status] || {};
  }

  public transformDate(value: string): number {
    let newDateSplit = value.split('T')[0].split('-');
    let newDate = new Date(
      `${newDateSplit[0]} / ${newDateSplit[1]}/${newDateSplit[2]}`
    ).getTime();
    return newDate;
  }

  //filtro personalizado

  public myFilterPredicate(data: any, filter: string): boolean {
    return data.status.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
  }
}
